module.exports = __webpack_public_path__ + "files/343f585130fd432e87daea0f64de3b50.png";